import { html } from 'lit';
import { SquareChartGantt } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-square-chart-gantt')
export class PdsIconSquareChartGantt extends PdsIcon {
  @state()
  icon = SquareChartGantt;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
